import { apiClient } from '@/api/api'
import type { TasteMatchingSwipeResponse, TasteMatchingSwipeScore } from '../types/taste-config'

export interface SubmitTasteMatchingSwipeParams {
  cardId: number
  action: 'like' | 'dislike' | 'skip'
  swipeTimeMs?: number
  sessionId?: string
  /** § 3.2 / BE-151 — the photo's rating, 0…100, agreeing with `action`; sent only when given. */
  score?: TasteMatchingSwipeScore
}

/** `POST /taste-matching/cards/{id}/swipe` — one rating of one outfit card (Style quiz › Rate). */
export async function submitTasteMatchingSwipe(
  params: SubmitTasteMatchingSwipeParams
): Promise<TasteMatchingSwipeResponse> {
  try {
    const { cardId, action, swipeTimeMs, sessionId, score } = params

    const body: {
      action: string
      swipeTimeMs?: number
      sessionId?: string
      score?: TasteMatchingSwipeScore
    } = {
      action
    }

    if (swipeTimeMs !== undefined) {
      body.swipeTimeMs = swipeTimeMs
    }

    if (sessionId) {
      body.sessionId = sessionId
    }

    if (score !== undefined) {
      body.score = score
    }

    const response = await apiClient.post<TasteMatchingSwipeResponse>(
      `/taste-matching/cards/${cardId}/swipe`,
      body
    )
    return response.data
  } catch (error) {
    console.error('Error submitting taste matching swipe:', error)
    throw error
  }
}
